import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Products from '../../Models/Products';
import { Image } from './Image';
// import {Transformation} from '';
class RecommandedSeller extends Component {
    constructor(props) {
        super(props)

        this.state = {
            images: [],
            productsList: [],
            alter: 2,
            layer: '',
            total: ''
        }
    }

    componentDidMount() {
        var affId = JSON.parse(localStorage.getItem('aff-id'))
        console.log(affId)
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (affId > 0) {
                Products.getProducts(this.props.id, 1, 1).then(res => {
                    if (res.data.payload != null) {
                        if (res.data.total % 2 == 0) {
                            var layer = res.data.total / 2;
                            this.setState({ productsList: res.data.payload, layer: layer })
                        } else {
                            const layer = res.data.total / 2;
                            this.setState({ productsList: res.data.payload, layer: parseInt(layer) + 1 })
                        }
                    }
                })
            } else {
                Products.getProducts(this.props.id, 1, 1).then(res => {
                    if (res.data.payload != null) {
                        if (res.data.total % 2 == 0) {
                            var layer = res.data.total / 2;
                            this.setState({ productsList: res.data.payload, layer: layer })
                        } else {
                            const layer = res.data.total / 2;
                            this.setState({ productsList: res.data.payload, layer: parseInt(layer) + 1 })
                        }
                    }
                })
            }
        } else if (isDesktop) {
            if (affId > 0) {
                Products.getProducts(this.props.id, 1, 0).then(res => {
                    if (res.data.payload != null) {
                        if (res.data.total % 6 == 0) {
                            var layer = res.data.total / 6;
                            this.setState({ productsList: res.data.payload, layer: layer })
                        } else {
                            const layer = res.data.total / 6;
                            this.setState({ productsList: res.data.payload, layer: parseInt(layer) + 1 })
                        }
                    }
                })
            } else {
                Products.getProducts(this.props.id, 1, 0).then(res => {
                    if (res.data.payload != null) {
                        if (res.data.total % 6 == 0) {
                            var layer = res.data.total / 6;
                            this.setState({ productsList: res.data.payload, layer: layer })
                        } else {
                            const layer = res.data.total / 6;
                            this.setState({ productsList: res.data.payload, layer: parseInt(layer) + 1 })
                        }
                    }
                })
            }
        } else if (window.innerWidth > 500 && window.innerWidth < 1200) {
            if (affId > 0) {
                Products.getProducts(this.props.id, 1, 2).then(res => {
                    if (res.data.payload != null) {
                        if (res.data.total % 3 == 0) {
                            var layer = res.data.total / 3;
                            this.setState({ productsList: res.data.payload, layer: layer })
                        } else {
                            const layer = res.data.total / 3;
                            this.setState({ productsList: res.data.payload, layer: parseInt(layer) + 1 })
                        }
                    }
                })
            } else {
                Products.getProducts(this.props.id, 1, 2).then(res => {
                    if (res.data.payload != null) {
                        if (res.data.total % 3 == 0) {
                            var layer = res.data.total / 3;
                            this.setState({ productsList: res.data.payload, layer: layer })
                        } else {
                            const layer = res.data.total / 3;
                            this.setState({ productsList: res.data.payload, layer: parseInt(layer) + 1 })
                        }
                    }
                })
            }
        }
    }

    handleClick(i, j) {

        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        console.log(this.state.layer)
        if (isMobile) {
            if (j === this.state.layer) {
                console.log(j)
                Products.getProducts(i, j, 1).then(res => {
                    if (res.data.payload != null) {
                        this.setState({ productsList: res.data.payload })
                    }
                })
                this.setState({ alter: 1 })
            } else {
                console.log('sad', j)
                console.log('sad', this.state.alter)
                Products.getProducts(i, j, 1).then(res => {
                    if (res.data.payload != null) {
                        this.setState({ productsList: res.data.payload })
                    }
                })
                this.setState({ alter: j + 1 })
            }
        } else if (isDesktop) {
            if (j === this.state.layer) {
                Products.getProducts(i, j, 0).then(res => {
                    if (res.data.payload != null) {
                        this.setState({ productsList: res.data.payload })
                    }
                })
                this.setState({ alter: 1 })
            } else {
                Products.getProducts(i, j, 0).then(res => {
                    if (res.data.payload != null) {
                        this.setState({ productsList: res.data.payload })
                    }
                })
                this.setState({ alter: j + 1 })
            }
        } else if (window.innerWidth > 500 && window.innerWidth < 1200) {
            if (j === this.state.layer) {
                console.log(j)
                Products.getProducts(i, j, 1).then(res => {
                    if (res.data.payload != null) {
                        this.setState({ productsList: res.data.payload })
                    }
                })
                this.setState({ alter: 1 })
            } else {
                console.log('sad', j)
                console.log('sad', this.state.alter)
                Products.getProducts(i, j, 1).then(res => {
                    if (res.data.payload != null) {
                        this.setState({ productsList: res.data.payload })
                    }
                })
                this.setState({ alter: j + 1 })
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            let Products = null;
            Products = this.state.productsList.map((item) => {
                return (
                    <div className=" pr-0 col-6" key={item.id} >
                        <div className="categories_grid" style={{ height: '210px' }}>
                            <Link to={{
                                pathname: `/categories-details/${item.id}`,
                                state: { id: item.id }
                            }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                <Image img={item.img} ></Image>
                            </Link>
                            <div className="categories_grid_text cut-content-resize">
                                <Link to={{
                                    pathname: `/categories-details/${item.id}`,
                                    state: { id: item.id }
                                }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                    {item.top_title}
                                </Link>
                            </div>
                            <div className=" categories_grid_text ">
                                <div className="row m-0">
                                    <div className="categories_grid_seller col-5 cut-content-resize p-0">
                                        {item.seller_short_name.substring(0, 6)}
                                    </div>
                                    <div className="categories_price col-7 cut-content-resize p-0" style={{ textAlign: 'end' }}>
                                        {parseInt(item.price)} 円
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });
            return (
                <div className="row">
                    <div className="col-10">
                        <div className="row" style={{ width: '96%' }}>
                            {Products}
                        </div>
                    </div>
                    <div className="col-2" style={{ verticalAlign: 'middle', marginTop: '80px' }}>
                        <button type='submit' style={{ height: '50px', width: "2px", border: '0px solid', backgroundColor: '#fff' }} onClick={this.handleClick.bind(this, this.props.id, this.state.alter)}>
                            <img alt="" src={require('../../assets/images/arrow.png')} style={{ height: '25px', width: '25px' }} />
                        </button>
                    </div>
                </div>

            )
        } else if (isDesktop) {
            let Products = null;
            Products = this.state.productsList.map((item) => {
                return (
                    <div className="products" key={item.id}>
                        <div className="categories_grid">
                            <Link to={{
                                pathname: `/categories-details/${item.id}`,
                                state: { id: item.id }
                            }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                <Image img={item.img} ></Image>
                            </Link>
                            <div className="categories_grid_text cut-content-resize">
                                <Link to={{
                                    pathname: `/categories-details/${item.id}`,
                                    state: { id: item.id }
                                }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                    {item.top_title}
                                </Link>
                            </div>
                            <div className="categories_grid_text row m-0" style={{paddingLeft: "5px", paddingRight: "5px"}}>
                                <div className="categories_grid_seller col-5 p-0 cut-content-resize" >
                                    {item.seller_short_name.substring(0, 6)}
                                </div>
                                <div className="categories_price col-7 p-0 cut-content-resize" style={{ textAlign: 'end' }}>
                                    {parseInt(item.price)} 円
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                )
            });
            return (
                <div className="row">
                    <div className="col-md-11 row pl-4" style={{ width: '775px', paddingRight: '0px', paddingLeft: '24px' }}>
                        {Products}
                    </div>
                    <div className="col-md-1 slider_button" style={{ verticalAlign: 'middle' }}>
                        <button type='submit' style={{ height: '28px', width: "25px", border: '1px solid' }} onClick={this.handleClick.bind(this, this.props.id, this.state.alter)}>
                            <img alt="" src={require('../../assets/images/arrow.png')} style={{ height: '15px', width: '15px' }} />
                        </button>
                    </div>
                </div>

            )
        } else if (window.innerWidth > 500 && window.innerWidth < 1200) {
            let Products = null;
            Products = this.state.productsList.map((item) => {
                return (
                    <div className="products" key={item.id}>
                        <div className="categories_grid">
                            <Link to={{
                                pathname: `/categories-details/${item.id}`,
                                state: { id: item.id }
                            }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                <Image img={item.img} ></Image>
                            </Link>
                            <div className="categories_grid_text">
                                <Link to={{
                                    pathname: `/categories-details/${item.id}`,
                                    state: { id: item.id }
                                }} style={{ fontSize: '10px', width: '100%' }} className="pt-2 arrow_cat category-right">
                                    {item.top_title}
                                </Link>
                            </div>
                            <div className=" categories_grid_text ">
                                <div className="row" style={{ marginLeft: '0px', marginRight: '-7px' }}>
                                    <div className="categories_grid_seller">
                                        {item.seller_short_name.substring(0, 6)}
                                    </div>
                                    {/* <div style={{ width: '12px' }}></div> */}
                                    <div className="categories_price">
                                        {parseInt(item.price)} 円
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                )
            });
            return (
                <div className="row">
                    <div className="row pl-4" style={{ width: '775px' }}>
                        {Products}
                    </div>
                    <div className="slider_button" style={{ verticalAlign: 'middle' }}>
                        <button type='submit' style={{ height: '28px', width: "25px", border: '1px solid' }} onClick={this.handleClick.bind(this, this.props.id, this.state.alter)}>
                            <img alt="" src={require('../../assets/images/arrow.png')} style={{ height: '15px', width: '15px' }} />
                        </button>
                    </div>
                </div>
            )
        }
    }
}
export { RecommandedSeller }
